/** Google's official four-colour "G". Required by their branding guidelines on any Google sign-in button. */
export const GoogleMark = ({ className = "w-5 h-5" }) => (
  <svg className={className} viewBox="0 0 48 48" aria-hidden="true" focusable="false">
    <path
      fill="#4285F4"
      d="M45.12 24.5c0-1.56-.14-3.06-.4-4.5H24v8.51h11.84a10.13 10.13 0 0 1-4.4 6.65v5.52h7.11c4.16-3.83 6.57-9.47 6.57-16.18z"
    />
    <path
      fill="#34A853"
      d="M24 46c5.94 0 10.92-1.97 14.55-5.32l-7.11-5.52c-1.97 1.32-4.49 2.1-7.44 2.1-5.72 0-10.56-3.86-12.28-9.06H4.34v5.7A21.99 21.99 0 0 0 24 46z"
    />
    <path
      fill="#FBBC05"
      d="M11.72 28.2A13.2 13.2 0 0 1 11.02 24c0-1.46.25-2.88.7-4.2v-5.7H4.34A21.99 21.99 0 0 0 2 24c0 3.55.85 6.91 2.34 9.9l7.38-5.7z"
    />
    <path
      fill="#EA4335"
      d="M24 10.75c3.23 0 6.13 1.11 8.41 3.29l6.31-6.31C34.91 4.18 29.93 2 24 2 15.4 2 7.96 6.93 4.34 14.1l7.38 5.7c1.72-5.2 6.56-9.05 12.28-9.05z"
    />
  </svg>
);
